import React from 'react'
import styled from 'styled-components'

import postImage from './post.jpg'

function Post() {
  return (
    <GridItemContainer>
      <PostHeader>Channel Name</PostHeader>
      <PostContent>
        {/* <img src={postImage} width={'100%'} alt="Title" /> */}
      </PostContent>
      <PostText>Social controls here</PostText>
    </GridItemContainer>
  )
}

export default Post

const GridItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: calc((100% / 4) - 40px);

  @media only screen and (max-width: 2200px) {
    width: calc((100% / 3) - 40px);
  }

  @media only screen and (max-width: 1600px) {
    width: calc((100% / 2) - 35px);
  }

  @media only screen and (max-width: 600px) {
    width: calc(100% - 35px);
  }

  border: 1px solid #404e53;
  margin: 15px 15px;
  border-radius: 2px;
`

const PostHeader = styled.div`
  padding: 15px;
`

const PostText = styled.div`
  padding: 15px;
`
const PostContent = styled.div`
  background: #374048;
  position: relative;

  &:before {
    content: '';
    display: block;
    padding-top: 100%;
  }
`
